const { debounce } = window.BAO.Utils

class ExternalPriceFilter extends window.BAO.CustomElement({
  SuperClass: HTMLFormElement,
}) {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.debouncedOnInput = debounce(this.onInput.bind(this), 700)

    this.querySelectorAll('input').forEach(input => {
      input.addEventListener('input', this.debouncedOnInput.bind(this))
    })
  }

  onInput (e) {
    if (!e.target?.name || !e.target?.value) return

    document.querySelector('.clc-ProductGridFacetsTablet').dispatchEvent(
      new CustomEvent('collection-filters:external-filter', {
        detail: {
          filterKey: e.target.name,
          filterValue: e.target.value,
        },
        bubbles: true,
      }),
    )
  }
}

if (!window.customElements.get('external-price-filter')) {
  window.customElements.define('external-price-filter', ExternalPriceFilter, {
    extends: 'form',
  })
}
